import Http from "./HttpService";

class FileTagsService extends Http {
  BASE_URL = "/admins/file-tags";

  getList(pagination) {
    return this.get(this.BASE_URL, { params: pagination });
  }
}

export default new FileTagsService();
